import * as React from "react";
import { connect } from "react-redux";
import GenericInput from "../common/input/GenericInput";
import * as types from "../../constants/actionTypes";
import DataComponent from "../common/DataComponent";
import { Modal, ModalBody, Tooltip } from 'reactstrap';
import YesNoModal from "../common/YesNoComponent";
import SectionLoadingError from '../common/SectionLoadingError';
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import ConfirmationModal from '../common/ConfirmationModal';
import SuccessBanner from './SuccessBanner';
import Spinner from "../common/spinner";
import TryAgainToolTip from '../common/TryAgainToolTip';

class LinkMyChartAccounts extends DataComponent {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                MyChartUserName: "",
                MyChartPassword: ""
            },
            showModal: false,
            modalText: null,
            modalYesFunction: null,
            modalNoFunction: null,
            inInputMode: props.openMyChart ? true : false,
            submitEnabled: false,
            showToolTip: false,
            showError: false
        };
        this.handleLinkMyChartAccountClick = this.handleLinkMyChartAccountClick.bind(this);
        this.handleUnlinkMyChartAccountClick = this.handleUnlinkMyChartAccountClick.bind(this);
        this.validateLinkMyChartInputs = this.validateLinkMyChartInputs.bind(this);
        this.handleLinkMyChartAccountClick2 = this.handleLinkMyChartAccountClick2.bind(this);
        this.cancelModal = this.cancelModal.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.handleUnlinkMyChartAccountClick2 = this.handleUnlinkMyChartAccountClick2.bind(this);
        this.handlePasswordKeyClick = this.handlePasswordKeyClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.toggleInputMode = this.toggleInputMode.bind(this);
        this.inputsChanged = this.inputsChanged.bind(this);
        this.isMobileQueryValue = Tools.isMobileQuery(props.location);
        this.isFromMobile = false;
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        this.isFromMobile = this.isMobileQueryValue || Tools.getItemFromSessionStorage('isMobile') || this.props.MobileOnQueryString;
        logUI("MBHWeb.UI.LinkMyChartAccounts.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { inInputMode } = this.state;
        if (inInputMode) {
            if ((prevProps.MyChartID !== this.props.MyChartID) ||
                (!prevProps.unlinkMyChartSuccessMessage && this.props.unlinkMyChartSuccessMessage) ||
                (!prevProps.linkMyChartSuccessMessage && this.props.linkMyChartSuccessMessage)) {
                this.setState({ inInputMode: false, showError: false });  // turn off the edit if an account was just delinked or linked
            }
        }
    }

    toggleInputMode() {
        const { inInputMode } = this.state;
        this.setState({ inInputMode: !inInputMode, showError: false }, () => Tools.setFocus('myChartId', !inInputMode));

    }

    toggleTooltip() {
        this.setState(prevState => ({
            showToolTip: !prevState.showToolTip
        }));
    }

    inputsChanged() {
        const { submitEnabled } = this.state;
        const bValid = this.validateLinkMyChartInputs();
        this.setState({ showError: false });
        if (bValid && !submitEnabled) {
            this.setState({ submitEnabled: true });
        }
        else if (!bValid && submitEnabled) {
            this.setState({ submitEnabled: false });
        }
    }

    handlePasswordKeyClick(e) {
        if (e.key.toLowerCase() === "enter") {
            this.handleLinkMyChartAccountClick();
        }
    }


    handleLinkMyChartAccountClick() {
        const { MyChartUserName } = this.state.fields;
        if (this.validateLinkMyChartInputs()) {
            this.setState({
                showModal: true,
                modalText: "Are you sure you want to link " + MyChartUserName + "?",
                modalYesFunction: this.handleLinkMyChartAccountClick2,
                modalNoFunction: this.cancelModal
            });
        }
    }
    handleLinkMyChartAccountClick2() {
        const { linkMyChartAccount } = this.props;
        const { MyChartUserName, MyChartPassword } = this.state.fields;
        this.cancelModal();
        logUI("MBHWeb.Account.MyChart.Link", new Date(), Tools.getURLPath());
        linkMyChartAccount(MyChartUserName, MyChartPassword, this.isFromMobile);
        this.setState({ showError: true })
        window.componentChanged = false;
    }

    cancelModal() {
        this.setState({
            showModal: false
        });
    }

    handleUnlinkMyChartAccountClick() {
        const { MyChartID } = this.props;
        if (!MyChartID)
            return;
        this.setState({
            showModal: true,
            modalText: "Are you sure you want to unlink " + MyChartID + "?",
            modalYesFunction: this.handleUnlinkMyChartAccountClick2,
            modalNoFunction: this.cancelModal
        });
    }
    handleUnlinkMyChartAccountClick2() {
        const { unlinkMyChartAccount } = this.props;
        this.cancelModal();
        logUI("MBHWeb.Account.MyChart.Unlink", new Date(), Tools.getURLPath());
        unlinkMyChartAccount(this.isFromMobile);
    }

    validateLinkMyChartInputs() {
        const { MyChartUserName, MyChartPassword } = this.state.fields;
        const { linkMyChartError } = this.props;
        if (Tools.isEmptyString(MyChartUserName) || Tools.isEmptyString(MyChartPassword)) {
            //linkMyChartError("You must supply a MyChart UserName and MyChart Password!");
            return false;
        }
        return true;
    }

    render() {
        const {
            technicalHelpDeskNumber,
            technicalHelpDeskHours,
            MyChartID,
            linkMyChartFailureMessage,
            linkMyChartSuccessMessage,
            linkMyChartInProcess,
            unlinkMyChartFailureMessage,
            unlinkMyChartSuccessMessage,
            unlinkMyChartInProcess,
            isProxyUser,
            MobileOnQueryString,
            epicEHRDown,
            registrationUrl
        } = this.props;
        const { showModal,
            modalYesFunction,
            modalNoFunction,
            modalText,
            inInputMode,
            showToolTip,
            submitEnabled,
            fields,
            showError
        } = this.state;

        //debugger;
        if (!this.bHasWindow) {
            console.log("Linked accounts render: MyChartID =" + MyChartID);
        }
        if (isProxyUser) {
            return "";
        }
        return (
            <div className="row">
                <YesNoModal showModal={showModal} modalText={modalText} modalYesFunction={modalYesFunction} modalNoFunction={modalNoFunction} />

                <div className="col-12 list-item-col not-linked">
                    <div className="row align-items-end">
                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="list-item-col__label">
                                Medical <span className="label-tooltip-nowrap">Records <span className="icon-question" id='lbl-mychart' /></span>
                                <Tooltip placement="top" isOpen={showToolTip} autohide={false} target="lbl-mychart" toggle={this.toggleTooltip}>
                                    Appointments, test results, messages, etc.
                                </Tooltip>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4 text-left text-sm-right text-lg-left">
                            <div className="list-item-col__info">
                                {epicEHRDown ? MyChartID ? <div className="list-item-col__info--linked">{MyChartID} <span className="icon-link"/></div>
                                    : <div className="list-item-col__info--unlinked">Not linked</div>
                                    : MyChartID ? <div className="list-item-col__info--linked">{MyChartID} <span className="icon-link" /></div>
                                        : linkMyChartSuccessMessage ? <div className="list-item-col__info--linked">{fields.MyChartUserName} <span className="icon-link" /></div>
                                            : <div className="list-item-col__info--unlinked">Not linked</div>}
                            </div>

                        </div>
                        <div className="col-12 col-lg-5 text-sm-right">
                            <div className="list-item-col__action action-msg">
                            {(unlinkMyChartInProcess || linkMyChartInProcess) ?
                                <Spinner /> :
                                epicEHRDown === false &&
                                    (MyChartID) 
                                        ? <React.Fragment>
                                            <div className="unlink-phone-link"><a href={"tel:" + technicalHelpDeskNumber} onClick={() => logUI("MBHWeb.Account.MyChart.Unlink.HelpDeskNumberClick", new Date(), Tools.getURLPath())} className="phone-link">To unlink call M - F 7AM - 6PM {/*`${technicalHelpDeskHours} `*/}{technicalHelpDeskNumber}</a></div>
                                        </React.Fragment>
                                        : <div>
                                            {epicEHRDown === true
                                                ?
                                                <React.Fragment>
                                                    <div id="myChart-link">
                                                        <button type="button" className="list-item-col__action btn btn-link-style btn-disabled">Link account</button>
                                                    </div>
                                                    <TryAgainToolTip target="myChart-link" />
                                                </React.Fragment>
                                                : !inInputMode  ? <button type="button" className="list-item-col__action--save btn btn-link-style" onClick={(e) => this.toggleInputMode()}>Link Account</button> : ""
                                            }
                                        </div>
                            }
                            </div>
                        </div>
                    </div>
                    {MyChartID || !inInputMode ? <div /> :
                        <div className="row">
                            {/*<div className="col-12 col-sm-6 form-group">*/}
                            {/*    <GenericInput name="MyChartUserName" placeholder="MyChart Username" id="myChartId"*/}
                            {/*        onChange={(e) => this.handleInputChange(e)} required autoComplete="new-password"*/}
                            {/*    />*/}
                            {/*</div>*/}
                            {/*<div className="col-12 col-sm-6 form-group">*/}
                            {/*    <GenericInput name="MyChartPassword" placeholder="MyChart Password" type="Password"*/}
                            {/*        onChange={(e) => this.handleInputChange(e)} onKeyPress={(e) => this.handlePasswordKeyClick(e)} required autoComplete="new-password"*/}
                            {/*    />*/}
                            {/*</div>*/}
                            {/*{showError &&*/}
                            {/*    <div className="col-12">*/}
                            {/*        {linkMyChartFailureMessage && <div className="error-msg" dangerouslySetInnerHTML={linkMyChartFailureMessage} />}*/}
                            {/*        {unlinkMyChartFailureMessage && <div className="error-msg" dangerouslySetInnerHTML={unlinkMyChartFailureMessage} />}*/}
                            {/*    </div>*/}
                            {/*}*/}
                            {/*{inInputMode && <div className="col-12 col-lg-12 text-sm-right">*/}
                            {/*    <div className="list-item-col__action">*/}
                            {/*        <button type="button" className="list-item-col__action--btn cancel btn" onClick={(e) => this.toggleInputMode()}>Cancel</button>*/}
                            {/*        <button type="button" className="list-item-col__action--btn btn" disabled={!submitEnabled} onClick={(e) => this.handleLinkMyChartAccountClick()}>Verify and link</button>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {/*}   */}
                            
                            {/*{!this.isFromMobile &&*/}
                            {/*    <div className="col-12">*/}
                            {/*        <div className={`info-banner ${showError ? " msg-above" : ""}`}>*/}
                            {/*        To link call, {technicalHelpDeskNumber} or to complete your registration with an activation code  <a href="https://register.mybswhealth.com/" target="_blank" onClick={() => logUI("MBHWeb.Account.MyChart.Link.DontHaveLogin.Clicked", new Date(), Tools.getURLPath())}>Click here</a>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*}*/}
                            <div className="col-12">
                                <div className="info-banner">
                                    To link call, <a href={"tel:" + technicalHelpDeskNumber} onClick={() => logUI("MBHWeb.Account.MyChart.Link.HelpDeskNumberClick", new Date(), Tools.getURLPath())} >{technicalHelpDeskNumber}</a> or to complete your registration with an activation code  <a href={registrationUrl + 'activation?s=1&option=Yes?'} target="_blank" onClick={() => logUI("MBHWeb.Account.MyChart.Link.DontHaveLogin.Clicked", new Date(), Tools.getURLPath())}>click here</a>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 text-sm-right">
                                <div className="list-item-col__action">
                                    <button type="button" className="list-item-col__action--btn cancel btn" onClick={(e) => this.toggleInputMode()}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    }
                    <SuccessBanner showMessage={!this.isFromMobile && (linkMyChartSuccessMessage || unlinkMyChartSuccessMessage)} message={linkMyChartSuccessMessage ? linkMyChartSuccessMessage : unlinkMyChartSuccessMessage ? unlinkMyChartSuccessMessage : ""} />
                </div>
                <ConfirmationModal when={inInputMode && (fields.MyChartUserName !== '' || fields.MyChartPassword !== '')} />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        technicalHelpDeskNumber: state.session.serverData.technicalHelpDeskNumber, 
        technicalHelpDeskHours: state.session.serverData.technicalHelpDeskHours,
        UserName: state.domain.un,
        MyChartID: state.domain.mc,
        linkMyChartInProcess: state.healthSource.linkMyChartInProcess,
        linkMyChartSuccessMessage: state.healthSource.linkMyChartSuccessMessage,
        linkMyChartFailureMessage: state.healthSource.linkMyChartFailureMessage,
        unlinkMyChartInProcess: state.healthSource.unlinkMyChartInProcess,
        unlinkMyChartSuccessMessage: state.healthSource.unlinkMyChartSuccessMessage,
        unlinkMyChartFailureMessage: state.healthSource.unlinkMyChartFailureMessage,
        isProxyUser: state.domain.ip,
        MobileOnQueryString: state.domain.mq,
        epicEHRDown: state.common.epicEHRDown,
        registrationUrl: state.session.serverData.myChartRegistrationUrl
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        linkMyChartAccount: (MyChartUserName, MyChartPassword, isFromMobile) => {
            dispatch({
                type: types.LINK_MYCHART_ACCOUNT_START,
                MyChartUserName,
                MyChartPassword,
                isFromMobile: isFromMobile
            });
        },
        unlinkMyChartAccount: (isFromMobile) => {
            dispatch({
                type: types.UNLINK_MYCHART_ACCOUNT_START,
                isFromMobile: isFromMobile
            });
        },
        linkMyChartError: (errorText) => {
            dispatch({
                type: types.LINK_MYCHART_ACCOUNT_FAILURE,
                errorText: errorText
            });
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkMyChartAccounts);